import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteAwardJudge: (
  fetchContext: FetchContext,
  awardJudgeId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardJudgeId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/award-judges/${awardJudgeId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete award judge'));
